export const Localize = {
    "en_GB": {
        "sessions": "Sessions",
        "contacts": "Contacts",
        "show_side_panel": "Show side panel",
        "hide_side_panel": "Hide side panel",
        "company_logo": "Company logo"
    },
    "de_DE": {
        "sessions": "Sitzungen",
        "contacts": "Kontakte",
        "show_side_panel": "Seitenleiste anzeigen",
        "hide_side_panel": "Seitenleiste ausblenden",
        "company_logo": "Firmenlogo"
    },
    "en_US": {
        "sessions": "Sessions",
        "contacts": "Contacts",
        "show_side_panel": "Show side panel",
        "hide_side_panel": "Hide side panel",
        "company_logo": "Company logo"
    },
    "en_AU": {
        "sessions": "Sessions",
        "contacts": "Contacts",
        "show_side_panel": "Show side panel",
        "hide_side_panel": "Hide side panel",
        "company_logo": "Company logo"
    },
    "es_ES": {
        "sessions": "Sesiones",
        "contacts": "Contactos",
        "show_side_panel": "Mostrar panel lateral",
        "hide_side_panel": "Ocultar panel lateral",
        "company_logo": "Logotipo de la empresa"
    },
    "es_MX": {
        "sessions": "Sesiones",
        "contacts": "Contactos",
        "show_side_panel": "Mostrar panel lateral",
        "hide_side_panel": "Ocultar panel lateral",
        "company_logo": "Logotipo de la empresa"
    },
    "es_AR": {
        "sessions": "Sesiones",
        "contacts": "Contactos",
        "show_side_panel": "Mostrar panel lateral",
        "hide_side_panel": "Ocultar panel lateral",
        "company_logo": "Logotipo de la empresa"
    },
    "fr_FR": {
        "sessions": "Sessions",
        "contacts": "Contacts",
        "show_side_panel": "Afficher le panneau latéral",
        "hide_side_panel": "Masquer le panneau latéral",
        "company_logo": "Logo de l'entreprise"
    },
    "en_CA": {
        "sessions": "Sessions",
        "contacts": "Contacts",
        "show_side_panel": "Show side panel",
        "hide_side_panel": "Hide side panel",
        "company_logo": "Company logo"
    },
    "fr_CA": {
        "sessions": "Sessions",
        "contacts": "Contacts",
        "show_side_panel": "Afficher le panneau latéral",
        "hide_side_panel": "Masquer le panneau latéral",
        "company_logo": "Logo de l'entreprise"
    },
    "pt_BR": {
        "sessions": "Sessões",
        "contacts": "Contatos",
        "show_side_panel": "Mostrar painel lateral",
        "hide_side_panel": "Ocultar painel lateral",
        "company_logo": "Logotipo da empresa"
    },
    "pt_PT": {
        "sessions": "Sessões",
        "contacts": "Contactos",
        "show_side_panel": "Mostrar painel lateral",
        "hide_side_panel": "Ocultar painel lateral",
        "company_logo": "Logótipo da empresa"
    },
    "it_IT": {
        "sessions": "Sessioni",
        "contacts": "Contatti",
        "show_side_panel": "Mostra pannello laterale",
        "hide_side_panel": "Nascondi pannello laterale",
        "company_logo": "Logo aziendale"
    },
    "zh_CN": {
        "sessions": "会话",
        "contacts": "联系人",
        "show_side_panel": "显示侧面板",
        "hide_side_panel": "隐藏侧面板",
        "company_logo": "公司徽标"
    },
    "ja_JP": {
        "sessions": "セッション",
        "contacts": "連絡先",
        "show_side_panel": "サイドパネルを表示",
        "hide_side_panel": "サイドパネルを非表示",
        "company_logo": "会社ロゴ"
    },
    "pl_PL": {
        "sessions": "Sesje",
        "contacts": "Kontakty",
        "show_side_panel": "Pokaż panel boczny",
        "hide_side_panel": "Ukryj panel boczny",
        "company_logo": "Logo firmy"
    },
    "ko_KR": {
        "sessions": "세션",
        "contacts": "연락처",
        "show_side_panel": "사이드 패널 표시",
        "hide_side_panel": "사이드 패널 숨기기",
        "company_logo": "회사 로고"
    }
};
